import { TextField } from "@material-ui/core";
import { trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import useOnDemandContentDisplay from '@/component/multiLanguage/hooks/useOnDemandContentDisplay';

function ContentEmailSubject({fieldData, disabled, setIsEditedCurrentTicket, currentMailSubject, setCurrentMailSubject, contentId, displayMode}) {
    // Re-render when the translation dictionary loads/extends so trLabel() text updates.
    useTranslationSubscription();

    // On-demand translation: when the 翻訳 toggle is ON and a translation exists,
    // show the translated subject as a read-only value WITHOUT touching the edit
    // state (currentMailSubject), so the form value stays the original.
    const { displayValue: onDemandSubject, isShowingTranslation } = useOnDemandContentDisplay(
        currentMailSubject,
        { contentId, fieldKey: fieldData?.id },
        displayMode
    );

    const handleInputChange = (e) => {
        const value = e.target.value
        setCurrentMailSubject(value)
        setIsEditedCurrentTicket(true)
    }

    const handleInputBlur = (e) => {
        const value = e.target.value
        setCurrentMailSubject(value.trim())
    }

    return (
        <div className='form-addTicket'>
            <div className="cell-prod-status gap-8"><label class="form-addTicket-label">{trLabel(fieldData?.name?.jp?.text)}</label></div>
            <TextField
                fullWidth
                variant="outlined"
                className={`form-control-wrapInput form-control-hg40 email-response-address-input`}
                inputProps={{style: {color: '#2E3138' }}}
                value={isShowingTranslation ? onDemandSubject : currentMailSubject}
                disabled={disabled || isShowingTranslation}
                onChange={e => handleInputChange(e)}
                onBlur={e => handleInputBlur(e)}
            />
        </div>
    );
}

export default ContentEmailSubject;
